import * as tslib_1 from "tslib";
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import { trace } from 'owa-trace';
import { ANCHOR_TAG_NAME } from './processAnchorElements';
import { OWA_REFERENCE_ATTACHMENTS_ID } from './shouldProcessLink';
import processAnchorElements, { AnchorElementsSource } from './processAnchorElements';
export default function processContentChangedFromSetContent(event, attachmentPlugin, viewState, parentItemIdWrapper, infoBarAddHandler, infoBarRemoveHandler, processedLinkIds) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var contentChangedEvent, allLinks, hiddenReferenceAttachments;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isAttachmentFeatureEnabled('doc-sharingTips-linkRemove')) {
                        return [2 /*return*/];
                    }
                    trace.info('processContentChangedFromSetContent');
                    contentChangedEvent = event;
                    if (contentChangedEvent.source !== "SetContent" /* SetContent */) {
                        return [2 /*return*/];
                    }
                    allLinks = attachmentPlugin.editor.queryContent(ANCHOR_TAG_NAME);
                    hiddenReferenceAttachments = attachmentPlugin.editor.queryContent('#' + OWA_REFERENCE_ATTACHMENTS_ID);
                    return [4 /*yield*/, processAnchorElements(allLinks, hiddenReferenceAttachments, AnchorElementsSource.ContentChangedFromSetContent, attachmentPlugin, viewState, parentItemIdWrapper, infoBarAddHandler, infoBarRemoveHandler, processedLinkIds)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=processContentChangedFromSetContent.js.map